import config from '@/config';
import { createGuestLambdaClient } from '../guestLambdaClient';
import { getIntegraApp } from '../lowLevel';
import { useStore } from '@/store';

const { region, lambdaArn } = config.services.integraLink;

export const client = createGuestLambdaClient({
  lambdaArn,
  region,
  getHeaders: async () => ({
    'app-version': config.app.version ?? '',
    'integra-app': await getIntegraApp(),
    'integra-auth': useStore().integraLinkJwt,
  }),
});
